<template>
  <div class="container mt-4">
  <!-- TOPO: Dados da locação e locatário -->
<div class="card p-3 mb-4 shadow-sm">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h4 class="text-uppercase fw-bold text-primary mb-0">Boleto da Locação</h4>
      <small class="text-muted">
        <strong>Pasta:</strong> {{ pasta }} |
        <strong>Referência do Imóvel:</strong> {{ boleto.loc_referencia || '---' }}
      </small>
    </div>

    <div class="d-flex align-items-center gap-3">
      <!-- Badge de status -->
      <span style="color:#FFF;"
        v-if="boleto.pago == 1"
        class="badge bg-success fs-5 px-4 py-2 text-uppercase shadow-sm mx-2"
      >
        Pago
      </span>
      <span style="color:#FFF;"
        v-else
        class="badge bg-danger fs-5 px-4 py-2 text-uppercase shadow-sm mx-2"
      >
        Em aberto
      </span>

      <!-- Botão Voltar -->
      <button class="btn btn-secondary" @click="$router.go(-1)">
        Voltar
      </button>
    </div>
  </div>

  <hr />

  <div class="row">
    <div class="col-md-6">
      <p class="mb-1"><strong>Locatário:</strong> {{ boleto.locatario_nome || '---' }}</p>
      <p class="mb-1"><strong>CPF:</strong> {{ boleto.locatario_cpf || '---' }}</p>
    </div>
    <div class="col-md-6">
      <p class="mb-1">
        <strong>Telefone:</strong>
        <a
          v-if="boleto.locatario_telefone1"
          :href="'https://wa.me/55' + boleto.locatario_telefone1.replace(/\D/g, '')"
          target="_blank"
          class="text-decoration-none"
        >
          {{ boleto.locatario_telefone1 }}
        </a>
        <span v-else>---</span>
      </p>
      <p class="mb-1"><strong>E-mail:</strong> {{ boleto.locatario_email || '---' }}</p>
    </div>
  </div>
</div>

    <!-- INFORMAÇÕES DO BOLETO -->
    <div class="card p-4">
      <h5 class="fw-bold text-primary">Informações do Boleto</h5>

      <div class="row g-3 mt-2">
        <div class="col-md-3">
          <label>Valor Aluguel</label>
          <input v-model="boleto.valor_aluguel" @input="formatarMoeda('valor_aluguel')" class="form-control" readonly />
        </div>
        <div class="col-md-2">
          <label>IPTU</label>
          <input v-model="boleto.valor_iptu" @input="formatarMoeda('valor_iptu')" class="form-control" readonly />
        </div>
         <div class="col-md-2">
          <label>S/Fiança</label>
          <input v-model="boleto.valor_fianca" @input="formatarMoeda('valor_fianca')" class="form-control" readonly />
        </div>
        <div class="col-md-2">
          <label>Taxa Boleto</label>
          <input v-model="boleto.valor_taxa_boleto" @input="formatarMoeda('valor_taxa_boleto')" class="form-control" readonly />
        </div>
        <div class="col-md-2">
          <label>Condomínio</label>
          <input v-model="boleto.valor_condominio" @input="formatarMoeda('valor_condominio')" class="form-control" />
        </div>
        <div class="col-md-3">
          <label>Seguro Incêndio</label>
          <input v-model="boleto.valor_seguro" @input="formatarMoeda('valor_seguro')" class="form-control" />
        </div>
        <div class="col-md-3">
          <label>Valor Total</label>
          <input v-model="boleto.valor_total" class="form-control" readonly />
        </div>
        <div class="col-md-3">
          <label>Vencimento</label>
          <input type="date" v-model="boleto.vencimento" class="form-control" />
        </div>
        <div class="col-md-3">
          <label>Pago?</label>
          <select v-model="boleto.pago" class="form-control" readonly>
            <option :value="0">Não</option>
            <option :value="1">Sim</option>
          </select>
        </div>
      </div>

      <div class="mt-3">
        <label>Informações Complementares</label>
        <textarea v-model="boleto.info" class="form-control"></textarea>
      </div>

      <!-- Campos Dinâmicos (Outros e Descontos) -->
      <div class="mt-4">
        <h6 class="fw-bold text-success">Outros Valores</h6>
        <div v-for="(item, index) in outros" :key="'outros-' + index" class="row g-2 align-items-center mb-2">
          <div class="col-md-6">
            <input v-model="item.descricao" class="form-control" placeholder="Descrição" />
          </div>
          <div class="col-md-4">
            <input v-model="item.valor" @input="formatarMoedaItem(item, 'valor')" class="form-control" placeholder="Valor" />
          </div>
          <div class="col-md-2 text-end">
            <button class="btn btn-danger" @click="removerItem('outros', index)">X</button>
          </div>
        </div>
        <button class="btn btn-outline-success mt-2" @click="adicionarItem('outros')">+ Adicionar Novo</button>
      </div>

      <div class="mt-4">
        <h6 class="fw-bold text-danger">Descontos</h6>
        <div v-for="(item, index) in descontos" :key="'descontos-' + index" class="row g-2 align-items-center mb-2">
          <div class="col-md-6">
            <input v-model="item.descricao" class="form-control" placeholder="Descrição" />
          </div>
          <div class="col-md-4">
            <input v-model="item.valor" @input="formatarMoedaItem(item, 'valor')" class="form-control" placeholder="Valor" />
          </div>
          <div class="col-md-2 text-end">
            <button class="btn btn-danger" @click="removerItem('descontos', index)">X</button>
          </div>
        </div>
        <button class="btn btn-outline-danger mt-2" @click="adicionarItem('descontos')">+ Adicionar Novo</button>
      </div>

      <div class="mt-4">
        <h6 class="fw-bold">Upload do Boleto (PDF)</h6>
        <input type="file" @change="uploadArquivo" accept="application/pdf" />
        <div v-if="boleto.arquivo_pdf" class="mt-3">
          <p><strong>Arquivo atual:</strong> {{ boleto.arquivo_pdf }}</p>
          <iframe
            :src="`${baseUrl}uploads/boletos/${boleto.arquivo_pdf}`"
            width="100%"
            height="400px"
          ></iframe>
        </div>
      </div>

      <div class="text-center mt-4">
        <button class="btn btn-primary me-2 mx-2" @click="salvarAlteracoes">💾 Salvar Alterações</button>
        <button  class="btn btn-warning mx-2" @click="enviarEmail">📧 Enviar Qr code / boleto ao Locatário</button>
        <button v-if="boleto.pago == 0" class="btn btn-success me-2 mx-2" @click="confirmarPagamento">✅ Confirmar Pagamento</button>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      baseUrl: "https://www2.royaljardim.com.br/sistema/",
      pasta: "",
      id: "",
      boleto: {},
      outros: [],
      descontos: [],
      arquivoSelecionado: null,
      total_pix:0.00
    };
  },
  mounted() {
    this.pasta = this.$route.params.pasta;
    this.id = this.$route.params.id;
    this.carregarBoleto();
  },
  methods: {
    carregarBoleto() {
      axios
        .post(this.baseUrl + "boletos_editar", new URLSearchParams({
          acao: "carregar",
          id: this.id,
        }))
        .then((res) => {
          this.boleto = res.data;

          // Corrige JSON com escapes
          const parseJsonSafe = (txt) => {
            try {
              if (!txt) return [];
              let clean = txt.replace(/\\"/g, '"').replace(/^"|"$/g, "");
              return JSON.parse(clean);
            } catch {
              return [];
            }
          };

          this.outros = parseJsonSafe(res.data.outros);
          this.descontos = parseJsonSafe(res.data.descontos);

          this.formatarTodosCamposMonetarios();
          this.recalcularTotal();
        });
    },
    adicionarItem(tipo) {
      if (tipo === "outros") this.outros.push({ descricao: "", valor: "R$ 0,00" });
      if (tipo === "descontos") this.descontos.push({ descricao: "", valor: "R$ 0,00" });
    },
    removerItem(tipo, index) {
      if (tipo === "outros") this.outros.splice(index, 1);
      if (tipo === "descontos") this.descontos.splice(index, 1);
      this.recalcularTotal();
    },
    formatarMoeda(campo) {
      this.boleto[campo] = this.formatarValor(this.boleto[campo]);
      this.recalcularTotal();
    },
    formatarMoedaItem(obj, prop) {
      obj[prop] = this.formatarValor(obj[prop]);
      this.recalcularTotal();
    },
    formatarValor(v) {
      v = (v || "").toString().replace(/[^\d]/g, "");
      const num = parseFloat(v) / 100 || 0;
      return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  parseMoeda(v) {
  if (v === null || v === undefined || v === "") return 0;

  // Converte para string e remove o símbolo de moeda e espaços
  let valor = v.toString().trim().replace("R$", "").replace(/\s/g, "");

  // Remove pontos de milhar, mas mantém a vírgula decimal
  valor = valor.replace(/\.(?=\d{3}(,|$))/g, "");

  // Substitui vírgula por ponto para conversão numérica
  valor = valor.replace(",", ".");

  const numero = parseFloat(valor);

  // Retorna 0 caso não seja número válido
  return isNaN(numero) ? 0 : numero;
},
    formatarTodosCamposMonetarios() {
      const campos = ["valor_aluguel", "valor_iptu", "valor_fianca", "valor_taxa_boleto", "valor_condominio", "valor_seguro"];
      campos.forEach(c => this.boleto[c] = this.formatarValor(this.boleto[c]));
      this.outros.forEach(o => o.valor = this.formatarValor(o.valor));
      this.descontos.forEach(d => d.valor = this.formatarValor(d.valor));
    },
    recalcularTotal() {
      let total =
        this.parseMoeda(this.boleto.valor_aluguel) +
        this.parseMoeda(this.boleto.valor_iptu) +
        this.parseMoeda(this.boleto.valor_fianca) +
        this.parseMoeda(this.boleto.valor_taxa_boleto) +
        this.parseMoeda(this.boleto.valor_condominio) +
        this.parseMoeda(this.boleto.valor_seguro);

      this.outros.forEach(o => total += this.parseMoeda(o.valor));
      this.descontos.forEach(d => total -= this.parseMoeda(d.valor));

      this.boleto.valor_total = total.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      this.total_pix = total;
    },
 salvarAlteracoes() {
  const boletoLimpo = { ...this.boleto };
  const camposMonetarios = [
    "valor_aluguel",
    "valor_iptu",
    "valor_fianca",
    "valor_taxa_boleto",
    "valor_condominio",
    "valor_seguro",
    "valor_total",
  ];

 camposMonetarios.forEach((campo) => {
  boletoLimpo[campo] = this.parseMoeda(this.boleto[campo]);
  console.log(boletoLimpo[campo]);
});

const limparArray = (arr) =>
  arr.map((item) => ({
    descricao: item.descricao,
    //valor: this.parseMoeda(item.valor),
     valor: item.valor,
  }));

  const outrosLimpos = limparArray(this.outros);
  const descontosLimpos = limparArray(this.descontos);

  const form = new FormData();
  form.append("acao", "salvar");
  form.append("id", this.id);

  for (let campo in boletoLimpo) {
    form.append(campo, boletoLimpo[campo]);
  }

  form.append("outros", JSON.stringify(outrosLimpos));
  form.append("descontos", JSON.stringify(descontosLimpos));

  axios.post(this.baseUrl + "boletos_editar", form).then(() => {
    alert("Alterações salvas com sucesso!");
    this.carregarBoleto();
  });
},
    uploadArquivo(e) {
      const arquivo = e.target.files[0];
      const form = new FormData();
      form.append("acao", "upload");
      form.append("id", this.id);
      form.append("arquivo", arquivo);

      axios.post(this.baseUrl + "boletos_editar", form).then(() => {
        alert("Arquivo enviado com sucesso!");
        this.carregarBoleto();
      });
    },
    confirmarPagamento() {
      if (confirm("Deseja confirmar o pagamento deste boleto?")) {
        axios
          .post(this.baseUrl + "boletos_editar", new URLSearchParams({
            acao: "confirmar_pagamento",
            id: this.id,
            pasta: this.pasta,
          }))
          .then((res) => {alert(res.data.mensagem);this.carregarBoleto();});
      }
    },
    enviarEmail() {
      axios
        .post(this.baseUrl + "boletos_editar", new URLSearchParams({
          acao: "enviar_email",
          id: this.id,
          valor: this.total_pix
        }))
        .then((res) => alert(res.data.mensagem));
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}
</style>